import { Subject } from 'rxjs';
import { EventType } from './EventType';
import { EventWithData } from './EventWithData';

const subject = new Subject<EventType>();
const dataSubject = new Subject<EventWithData>();

export const eventDispatcher = {
    sendEvent: (eventType: EventType) => subject.next(eventType),
    clearEvents: () => subject.next(),
    getEventObserver: () => subject.asObservable(),
    sendEventWithData: (eventType: EventType, data: any) => dataSubject.next(new EventWithData(eventType, data)),
    clearDataEvents: () => dataSubject.next(),
    getEventAndDataObserver: () => dataSubject.asObservable()
};